module.exports = __webpack_public_path__ + "img/3@2x.9e3d585a.png";